import { BaseResource } from '@/models/_base.model';
import { Account } from '@/models/account.model';
import { Address, CreateAddressDto } from '@/models/address.model';
import { GenderEnum } from '@/models/common.model';
import { User as Auth0BaseUser } from '@auth0/auth0-react';

export enum RoleEnum {
  SUPERUSER = 'superuser',
  CX = 'customer_success',
  ACCOUNT_ADMIN = 'account_admin',
  ACCOUNT_PROVIDER = 'account_provider',
  ACCOUNT_MEMBER = 'account_member'
}

export enum AdminRoleEnum {
  SUPERUSER = 'superuser',
  CX = 'customer_success'
}

export enum UserTypeEnum {
  ADMIN = 'admin',
  PRACTITIONER = 'practitioner'
}

export enum PractitionerTypeEnum {
  PRACTITIONER = 'practitioner',
  PROVIDER = 'provider'
}

export enum AccessScopeEnum {
  GLOBAL = 'global',
  ACCOUNT = 'account'
}

export type UserFlatRelationship = BaseResource & {
  firstName: string;
  lastName: string;
  fullName: string;
  initials: string;
  email: string;
  imageUrl: string | null;
};

export type ResponsibleProviderUser = UserFlatRelationship & {
  specialization: string | null;
  npi: string;
};

export type User = BaseResource & {
  firstName: string;
  lastName: string;
  formattedName: string;
  email: string;
  phone: string | null;
  role: RoleEnum;
  userType: UserTypeEnum;
  practitionerType: PractitionerTypeEnum | null;
  isActive: boolean;
  fullName: string;
  initials: string;
  honorific: string | null;
  credentials: string[] | null;
  accountId: string | null;
  npi: string | null;
  dea: string | null;
  specialization: string | null;
  isIncentiveGameParticipant: boolean;
  gender: GenderEnum;
  imageUrl: string | null;
  address: Address | null;
};

export type CurrentUser = User & {
  account: Account | null;
};

export type CreateUserDto = {
  accountId: string | null;
  firstName: string;
  lastName: string;
  honorific: string | null;
  credentials: string[] | null;
  email: string;
  password: string;
  phone: string | null;
  address?: CreateAddressDto | null;
  gender?: string | null;
  npi?: string | null;
  dea?: string | null;
  specialization?: string | null;
  role: RoleEnum;
  userType: UserTypeEnum;
  accessScope: AccessScopeEnum;
  practitionerType: PractitionerTypeEnum | null;
};

export type UpdateUserDto = Partial<{
  firstName: string;
  lastName: string;
  honorific: string | null;
  credentials: string[] | null;
  email: string;
  phone: string | null;
  address: CreateAddressDto | null;
  gender: string | null;
  npi: string | null;
  dea: string | null;
  specialization?: string | null;
  imageUrl: null;
}>;

export type Auth0User = Auth0BaseUser & {
  accountId?: string;
};
